/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Mark_Ready_Confirm_MessageInputs */

const fr_week_session_mark_ready_confirm_message = /** @type {(inputs: Week_Session_Mark_Ready_Confirm_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois marquée comme prête, l'athlète pourra voir et commencer cette semaine d'entraînement. Vous pourrez toujours modifier les sessions après.`)
};

/**

* @param {Week_Session_Mark_Ready_Confirm_MessageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_mark_ready_confirm_message = /** @type {((inputs?: Week_Session_Mark_Ready_Confirm_MessageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Mark_Ready_Confirm_MessageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_mark_ready_confirm_message(inputs)
});